<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="value"
      fullscreen
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card flat>
        <v-toolbar dark color="gradiente">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-toolbar height="140" v-if="subgroup" style=" z-index:99">
          <v-container>
            <v-layout row>
              <v-flex xs12 px-4>
                <v-toolbar-title>Detalle del subgrupo</v-toolbar-title>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 md3 lg3>
                <v-list light style="background-color: transparent">
                  <div class="padding-side">
                    <v-text-field
                      :value="subgroup ? subgroup.name : ''"
                      rows="1"
                      row-height="24"
                      auto-grow
                      prepend-icon="title"
                      disabled
                    />
                  </div>
                </v-list>
              </v-flex>
              <v-flex xs12 md2 lg2>
                <v-list light style="background-color: transparent">
                  <v-list-tile avatar>
                    <v-list-tile-avatar>
                      <v-icon class="red--text">flag</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Nivel</v-list-tile-title>
                      <v-list-tile-sub-title v-if="subgroup">
                        {{ subgroup.level.typeLevel }}
                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex xs12 md2 lg2>
                <v-list light style="background-color: transparent">
                  <v-list-tile avatar>
                    <v-list-tile-avatar>
                      <v-icon class="red--text">group</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Grado y grupo</v-list-tile-title>
                      <v-list-tile-sub-title v-if="subgroup.gradeGroup"
                        >{{ subgroup.gradeGroup.grade }}
                        {{ subgroup.gradeGroup.group }}</v-list-tile-sub-title
                      >
                      <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex xs12 md3 lg3>
                <v-list light style="background-color: transparent">
                  <v-list-tile avatar>
                    <v-list-tile-avatar>
                      <v-icon class="red--text">insert_invitation</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Días</v-list-tile-title>
                      <v-list-tile-sub-title v-if="subgroup">
                        {{ subgroup | daysFilter }}
                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
              <v-flex xs12 md3 lg3 class="titleSearch">
                <v-text-field
                  flat
                  label="Buscar"
                  append-outer-icon="search"
                  clearable
                  solo-inverted
                  hide-details
                  @click:append-outer="filterSearch(false)"
                  @click:clear="filterSearch(true)"
                  @keyup.enter="filterSearch(false)"
                  v-model="search"
                />
              </v-flex>
            </v-layout>
          </v-container>
          <v-speed-dial
            v-if="permits['UPDATE_SUBGROUPS']"
            key="1"
            absolute
            bottom
            left
            direction="bottom"
            open-on-hover
            transition="scale-transition"
            style="bottom: 0; z-index: 99999;"
          >
            <template v-slot:activator>
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-btn
                    style=" z-index:99"
                    color="gradiente"
                    dark
                    fab
                    :small="$vuetify.breakpoint.xsOnly"
                    v-on="on"
                  >
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <span>Opciones de subgrupos</span>
              </v-tooltip>
            </template>
            <v-tooltip right>
              <v-btn
                style=" z-index:99"
                fab
                dark
                small
                color="gradiente"
                slot="activator"
                @click="addStudent"
              >
                <v-icon>add</v-icon>
              </v-btn>
              <span>Agregar estudiante</span>
            </v-tooltip>
            <v-tooltip right>
              <v-btn
                style=" z-index:99"
                fab
                dark
                small
                color="gradiente"
                slot="activator"
                @click="notifySubgroup"
              >
                <v-icon>send</v-icon>
              </v-btn>
              <span>Enviar horarios</span>
            </v-tooltip>
          </v-speed-dial>
        </v-toolbar>
        <v-container fluid style="max-height: 93vh" class="scrollDesign table-full">
          <v-layout row wrap>
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :total-items="totalItemsFromBackend"
                :rows-per-page-items="[10, 15, 25]"
                rows-per-page-text="Registros por página"
                :items="subgroupStudents"
                :loading="working.wSubgroups"
                :pagination.sync="pagination"
                item-key="id"
                no-results-text="No se encontraron coincidencias"
                :no-data-text="
                  working.wSubgroups
                    ? 'Cargando'
                    : subgroupStudents.length > 0
                    ? ''
                    : 'No hay alumnos'
                "
              >
                <template v-slot:headers>
                  <tr>
                    <th
                      class="text-xs-left"
                      style="width: 78px; max-width: 78px; min-width: 78px"
                    >
                      Foto
                    </th>
                    <th
                      class="text-xs-left"
                      style="width: 500px; max-width: 500px; min-width: 500px"
                    >
                      Nombre
                    </th>
                    <th
                      class="text-xs-left"
                      style="width: 400px; max-width: 400px; min-width: 400px"
                    >
                      Apellidos
                    </th>
                    <th
                      class="text-xs-left"
                      style="width: 230px; max-width: 230px; min-width: 230px"
                    >
                      Género
                    </th>
                    <th
                      class="text-xs-left"
                      style="width: 230px; max-width: 230px; min-width: 230px"
                    >
                      Grupo
                    </th>
                    <th
                      class="text-xs-left"
                      style="width: 100px; max-width: 100px; min-width: 100px"
                    >
                      &nbsp;
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <td
                    class="text-xs-left"
                    style="width: 78px; max-width: 78px; min-width: 78px"
                  >
                    <v-avatar
                      :title="props.item.firstName"
                      :size="avatarSize"
                      color="grey lighten-4"
                      v-if="
                        props.item.imageStorage &&
                        props.item.imageStorage.miniObjUrl
                      "
                    >
                      <img
                        :src="props.item.imageStorage.miniObjUrl"
                        alt="avatar"
                      />
                    </v-avatar>
                    <v-icon :size="avatarSize" v-else>account_circle</v-icon>
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 500px; max-width: 500px; min-width: 500px"
                  >
                    {{ props.item.firstName }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 400px; max-width: 400px; min-width: 400px"
                  >
                    {{ props.item.lastName }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 230px; max-width: 230px; min-width: 230px"
                  >
                    <v-avatar>
                      <v-icon
                        :color="props.item.gender == 'MALE' ? 'blue' : 'pink'"
                        >account_circle</v-icon
                      >
                    </v-avatar>
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 230px; max-width: 230px; min-width: 230px"
                  >
                    {{ props.item.gradeGroup ? (props.item.gradeGroup.grade + props.item.gradeGroup.group) : "---" }}
                  </td>
                  <td
                    class="text-xs-right"
                    style="width: 100px; max-width: 100px; min-width: 100px"
                  >
                    <v-btn
                      @click="deleteStudent(props.item)"
                      icon
                      :disabled="!permits['UPDATE_SUBGROUPS']"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
                <template v-slot:pageText="props"
                  >{{ props.pageStart }} - {{ props.pageStop }} de
                  {{ props.itemsLength }}</template
                >
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>

        <desition
          @desition="$event ? onDeleteStudent() : ''"
          v-model="modals.delete"
          title="Dar de baja"
          :description="modals.description"
        />
        <desition
          @desition="$event ? onConfirmNotify() : ''"
          v-model="modals.notify"
          title="Confirmar"
          description="Se enviarán notificaciones a los papás de los alumnos que conforman este subgrupo. <br/> ¿Deseas continuar?"
        />
        <AddStudentModal
          v-if="modals.addStudent"
          :subgroup="subgroup"
          @cancelled="onCancelAdd"
          @confirmed="onConfirmedAdd"
        />
        <loading v-model="working.wSubgroups" text="Trabajando" />
        <success v-model="toast.success" text="Operación exitosa" />
        <error v-model="toast.failed" text="Ups ocurrió un error" />
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import desition from "../../Dialogs/Confirm";
import loading from "../../Dialogs/Loading";
import success from "../../Dialogs/Success";
import error from "../../Dialogs/Error";
import AddStudentModal from "./AddStudentModal";

export default {
  props: ["value", "subgroup"],
  components: {
    loading,
    success,
    error,
    desition,
    AddStudentModal,
  },
  data: () => ({
    permits: [],
    pagination: {
      sortBy: "name",
    },
    filters: {
      search: "",
    },
    working: {
      wSubgroups: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    modals: {
      delete: false,
      description: "",
      addStudent: false,
      notify: false,
    },
    search: "",
    startDateSearch: "",
    endDateSearch: "",
    avatarSize: "30px",
    subgroupStudents: [],
    headers: [
      {
        text: "Foto",
        align: "left",
        value: "imageStorage.miniObjUrl",
        filterItems: [],
      },
      {
        text: "Nombre",
        align: "left",
        value: "firstName",
        filterItems: [],
      },
      {
        text: "Apellido",
        align: "left",
        value: "lastName",
        filterItems: [],
      },
      {
        text: "Genero",
        align: "left",
        value: "gender",
        filterItems: [],
      },
      {
        text: "Actions",
        align: "right",
        value: "id",
        filterItems: [],
      },
    ],
    student: {},
    totalItemsFromBackend: 0,
  }),
  watch: {
    value() {
      if (this.value) {
        this.$forceUpdate();
      }
      if (this.value && this.subgroup != null) {
        this.getSubgroupStudents(this.subgroup.id);
      }
    },
    getUser() {
      if (this.getUser.id) this.mapPermits();
    },
    pagination: {
      handler() {
        if ( this.pagination.rowsPerPage && this.pagination.page && this.pagination.sortBy) {
          this.filters.size = this.pagination.rowsPerPage;
          this.filters.offset = (this.pagination.page - 1) * this.pagination.rowsPerPage;

          if(this.value){
            this.getSubgroupStudents(this.subgroup.id);
          }
        }
      },
      deep: true
    }
  },
  methods: {
    filterSearch(clean) {
      if(!clean){
        this.filters.search = this.search ? this.search : "";
      } else {
        this.filters.search = "";
      }
      if(!this.working.wLoading){
        this.getSubgroupStudents(true);
      }
    },
    deleteStudent(student) {
      this.student = student;
      this.modals.delete = true;
      this.modals.description =
        "Se dará de baja a " +
        student.firstName +
        " del subgrupo " +
        this.subgroup.name +
        ". <br> ¿Desea continuar?";
    },
    onDeleteStudent() {
      this.modals.delete = false;
      this.modals.description = "";
      if (!this.student) return;

      this.working.wSubgroups = true;
      this.$store
        .dispatch("subgroups/deleteStudent", {
          subgroup_id: this.subgroup.id,
          student_id: this.student.id,
        })
        .then(() => {
          this.toast.success = true;
          this.getSubgroupStudents(this.subgroup.id);
        })
        .catch(() => {
          this.toast.failed = true;
        })
        .finally(() => {
          this.working.wSubgroups = false;
          delete this.student;
        });
    },
    getSubgroupStudents(id) {
      this.working.wSubgroups = true;
      var offset = "";
      var pageSize = "";
      if (this.pagination.rowsPerPage !== undefined) {
        offset = (this.pagination.page - 1) * this.pagination.rowsPerPage;
        pageSize = this.pagination.rowsPerPage;
      } else {
        offset = 0;
        pageSize = 10;
      }
      var params = {
        search: this.filters.search,
        page_size: pageSize,
        offset: offset,
      };
      this.$store
        .dispatch("subgroups/getDetail", { id: id, params: params })
        .then((response) => {
          this.working.wSubgroups = false;
          this.subgroupStudents = response.data.students;
          this.totalItemsFromBackend = response.data.total
          this.$forceUpdate();
        })
        .catch(() => {
          this.working.wSubgroups = false;
        });
    },
    close() {
      this.filters.search = "";
      this.search = "";
      this.$emit("input", !this.value);
    },
    filterSearch(clean) {
      if (!clean) {
        this.filters.search = this.search ? this.search : "";
      } else {
        this.filters.search = "";
      }
      if (!this.working.wSubgroups) {
        this.getSubgroupStudents(this.subgroup.id);
      }
    },
    mapPermits() {
      var usr = this.getUser;
      var wbRol = usr.webRole;
      var catalogs = wbRol.catalogs;
      for (var c in catalogs) {
        if (catalogs[c].name.includes("SUBGROUPS")) {
          this.permits[catalogs[c].name] = 1;
        }
      }
    },
    onCancelAdd() {
      this.modals.addStudent = false;
    },
    onConfirmedAdd(data) {
      this.modals.addStudent = false;
      if (!data && !data.idStudent) {
        this.toast.failed = true;
        return;
      }

      this.working.wSubgroups = true;
      this.$store
        .dispatch("subgroups/addStudent", {
          subgroup_id: this.subgroup.id,
          student_id: data.idStudent,
        })
        .then(() => {
          this.toast.success = true;
          this.getSubgroupStudents(this.subgroup.id);
        })
        .catch(() => {
          this.toast.failed = true;
        })
        .finally(() => {
          this.working.wSubgroups = false;
        });
    },
    addStudent() {
      this.modals.addStudent = true;
    },
    notifySubgroup() {
      this.modals.notify = true;
    },
    onCancelNotify() {
      this.modals.notify = false;
    },
    onConfirmNotify() {
      this.working.wSubgroups = true;
      this.$store
        .dispatch("subgroups/notifySubgroup", this.subgroup.id)
        .then(() => {
          this.toast.success = true;
        })
        .catch(() => {
          this.toast.failed = true;
        })
        .finally(() => {
          this.working.wSubgroups = false;
        });
    },
  },
  filters: {
    daysFilter: function (subgroup) {
      var response = "";
      if (subgroup.monday) {
        response += "Lunes";
      }
      if (subgroup.tuesday) {
        response = response.length == 0 ? "Martes" : response + " - Martes";
      }
      if (subgroup.wednesday) {
        response =
          response.length == 0 ? "Miércoles" : response + " - Miércoles";
      }
      if (subgroup.thursday) {
        response = response.length == 0 ? "Jueves" : response + " - Jueves";
      }
      if (subgroup.friday) {
        response = response.length == 0 ? "Viernes" : response + " - Viernes";
      }
      if (subgroup.saturday) {
        response = response.length == 0 ? "Sábado" : response + " - Sábado";
      }
      if (subgroup.sunday) {
        response = response.length == 0 ? "Domingo" : response + " - Domingo";
      }
      return response;
    },
    genderFilter: function (gender) {
      switch (gender) {
        case "MALE":
          return "Masculino";
        case "FEMALE":
          return "Femenino";
      }
    },
  },
  mounted() {
    if (this.getUser.id) this.mapPermits();
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
};
</script>

<style>
  .titleSearch .v-input .v-input__slot {
    border-radius: 33px !important;
  }
</style>
<style scoped>
/deep/ .table-full .v-datatable.v-table > tbody {
  max-height: calc(105vh - 426px);
  min-height: calc(105vh - 426px);
}
</style>